import { c as _c } from "react/compiler-runtime";
import { PatientDynamicFieldType } from "@/types/enums/patient-health-field";
import PatientHealthFieldDialog from "./patient-health-field-dialog";
const ALLERGIES_CONFIG = {
  type: PatientDynamicFieldType.ALLERGIES,
  title: "Allergies",
  description: "Add known allergies. Information from patient forms will appear here automatically.",
  placeholder: "e.g., Penicillin, Peanuts",
  addButtonText: "Add allergy",
  addAnotherButtonText: "Add another allergy"
};
interface AllergiesDialogProps {
  children?: React.ReactNode;
  patientId: string;
}
export default function AllergiesDialog(t0) {
  const $ = _c(3);
  const {
    children,
    patientId
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== patientId) {
    t1 = <PatientHealthFieldDialog config={ALLERGIES_CONFIG} patientId={patientId}>{children}</PatientHealthFieldDialog>;
    $[0] = children;
    $[1] = patientId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}